import { render, staticRenderFns } from "./SixView.vue?vue&type=template&id=75d33ed4"
import script from "./SixView.vue?vue&type=script&lang=js"
export * from "./SixView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports